export abstract class Base<T> {

  id?: number;

  constructor(model?: Partial<T>) {
    Object.assign(this, model);
  }
}